import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useTitanApp } from "@/hooks/useTitanApp";
import { updateCurrentMemberProfile } from "@/dispatchers/memberDispatchers";
import fileToBase64 from "@/utils/fileToBase64";

interface User {
  firstName: string;
  lastName: string;
  emailAddress: string;
  gphcNumber: string;
  userImage: string | null;
}

export const useGeneralProfileData = () => {
  const { appState, memberState } = useTitanApp();
  const { darkMode } = appState || {};
  const { currentMember, isCurrentProfileLoading, isMemberLoading } =
    memberState || {};
  const { firstName,lastName, emailAddress, userImage, gphcNumber } = currentMember || {};
  const isDarkMode = darkMode ?? false;
  const form = useForm<User>({
    mode: "onChange",
    defaultValues: {
      firstName: firstName,
      lastName: lastName,
      emailAddress: emailAddress,
      gphcNumber: gphcNumber,
      userImage: userImage,
    },
  });
  const { register, handleSubmit, setValue, watch, reset, formState } = form;
  const { errors, isDirty, isValid } = formState;
  // Watch userImage field for changes
  const userImageWatch = watch("userImage");

  useEffect(() => {
    if (currentMember) {
      reset({
        firstName: currentMember.firstName || "",
        lastName: currentMember.lastName || "",
        emailAddress: currentMember.emailAddress || "",
        gphcNumber: currentMember.gphcNumber || "",
        userImage: currentMember.userImage || null,
      });
    }
  }, [currentMember, reset]);

  const onSubmit = async (data: User) => {
    const payload = {
      firstName: data.firstName || "",
      lastName: data.lastName || "",
      emailAddress: data.emailAddress,
      gphcNumber: data.gphcNumber,
      userImage: data.userImage,
    };
    await updateCurrentMemberProfile(payload);
  };

  return {
    isDarkMode,
    isCurrentProfileLoading,
    isMemberLoading,
    register,
    handleSubmit,
    onSubmit,
    setValue,
    errors,
    isDirty,
    isValid,
    userImage,
    userImageWatch,
    fileToBase64,
  };
};
